import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=30394538&scoped=true"
import script from "./ArticleListItem.vue?vue&type=script&lang=ts"
export * from "./ArticleListItem.vue?vue&type=script&lang=ts"
import style0 from "./ArticleListItem.vue?vue&type=style&index=0&id=30394538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30394538",
  null
  
)

export default component.exports